export * from './storage-location-add-edit.component';
export * from './storage-location-view.component';